import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { GroupId } from 'services/groups/types';
import { AppState } from 'services/types';
import RoleButtonLink from 'components/RoleButtonLink';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import GroupName from 'components/GroupName';
import { makeSelectGroupTimesheetAlreadyExistLength } from '../GroupTimesheetAlreadyExistGate/selectors';

export interface Props {
    startDate?: string;
    groupId?: GroupId;
}

export default function GroupTimesheetAlreadyExistButton(
    props: Props
): ReactElement | null {
    const { groupId, startDate } = props;

    const groupTimesheetAlreadyExistLength = useSelector((state: AppState) =>
        makeSelectGroupTimesheetAlreadyExistLength()(state, props)
    );

    if (groupTimesheetAlreadyExistLength) {
        return (
            <RoleButtonLink
                requiredRoles={[ADMIN, MANAGER]}
                buttonProps={{
                    primary: true,
                    type: 'button'
                }}
                params={{
                    page: undefined,
                    count: undefined,
                    entities: undefined,
                    workTypes: undefined,
                    groupTimesheetModal: undefined,
                    groups: [groupId],
                    date: startDate
                }}
            >
                There are already {groupTimesheetAlreadyExistLength} timesheets
                for <GroupName groupId={groupId} />
            </RoleButtonLink>
        );
    }

    return null;
}
